import React from 'react';
import {NavLink} from 'react-router-dom';
import clsx from 'clsx';
import {colors} from '../../utils/constants';
import {Avatar} from '../Avatar';
import {avatarSizes} from '../Avatar/types';
import styles from './Navigation.module.scss';
import {mobileScreens} from './config';

export const NavigationMobile = () => {
    return (
        <div className={styles.navigationMobile}>
            {mobileScreens.map(({path, label, Icon}, index) => {
                if (path === '/profile') {
                    return (
                        <NavLink
                            key={index}
                            to={path}
                            className={({isActive}) =>
                                clsx(styles.navigationMobile__link, isActive && styles.navigationMobile__linkActive)
                            }
                        >
                            <Avatar full_name={undefined} size={avatarSizes.sm} />
                            {label}
                        </NavLink>
                    );
                }

                return (
                    <NavLink
                        key={index}
                        to={path}
                        className={({isActive}) =>
                            clsx(styles.navigationMobile__link, isActive && styles.navigationMobile__linkActive)
                        }
                    >
                        <Icon
                            width={16}
                            height={18}
                            color="currentColor"
                            style={{marginBottom: '6px'}}
                        />
                        {label}
                    </NavLink>
                );
            })}
        </div>
    );
};
